import { render, staticRenderFns } from "./CustomerRenewalOrderFaPiao.vue?vue&type=template&id=a0286666&scoped=true&"
import script from "./CustomerRenewalOrderFaPiao.vue?vue&type=script&lang=js&"
export * from "./CustomerRenewalOrderFaPiao.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRenewalOrderFaPiao.vue?vue&type=style&index=0&id=a0286666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0286666",
  null
  
)

export default component.exports